import TagManager from 'react-gtm-module';

/**
 * FIN-7470 (T16 / C3DS-11): etapas do funil de autenticação. Nomes canônicos —
 * medem onde a autenticação cai, sem carregar nada do provider.
 */
export const THREE_DS_EVENTS = {
  COLLECT: 'three_ds_collect',
  CHALLENGE_PRESENTED: 'three_ds_challenge_presented',
  CHALLENGE_COMPLETED: 'three_ds_challenge_completed',
  ABANDONED: 'three_ds_abandoned',
  /** Rede: comprador enviado ao ACS por navegação de página inteira. */
  REDIRECT: 'three_ds_redirect',
} as const;

export type ThreeDsEvent =
  (typeof THREE_DS_EVENTS)[keyof typeof THREE_DS_EVENTS];

export interface ThreeDsEventIdentifiers {
  /** Identificador da compra — o mesmo `transaction_id` do resto do funil. */
  cartId?: string;
  chargeId?: string;
}

/**
 * Registra uma etapa do funil na mesma camada de telemetria que o checkout já
 * usa. Telemetria nunca pode derrubar um pagamento: qualquer falha aqui é
 * engolida de propósito.
 */
export const trackThreeDsEvent = (
  event: ThreeDsEvent,
  { cartId, chargeId }: ThreeDsEventIdentifiers = {}
): void => {
  try {
    TagManager.dataLayer({
      dataLayer: {
        event,
        three_ds_step: event,
        ...(cartId && { transaction_id: cartId }),
        ...(chargeId && { charge_id: chargeId }),
      },
    });
  } catch {
    // Sem telemetria a compra segue; o contrário não pode acontecer.
  }
};
